import { setCropList } from 'crops';

export const processCropList = ({ dispatch, cropList }) => {
  dispatch(setCropList( {crops: cropList} ));
  return Promise.resolve( cropList );
};
